const facilities = [
  {
    name: "Fargo Main Post Office",
    address: "657 2nd Ave N, Fargo, ND 58102",
    hours: "Mon–Fri 8:30am–5:00pm",
    phone: "(701) 241-6300",
    type: "Post Office",
    notes: "Primary passport acceptance facility for downtown Fargo. Accepts walk-ins.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "West Fargo Post Office",
    address: "720 13th Ave E, West Fargo, ND 58078",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(701) 282-2332",
    type: "Post Office",
    notes: "Convenient for West Fargo and Sheyenne Street corridor residents.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Cass County Clerk of Courts",
    address: "211 9th St S, Fargo, ND 58103",
    hours: "Mon–Fri 8:00am–4:30pm",
    phone: "(701) 241-5600",
    type: "County Clerk",
    notes: "Accepts passport applications. ID verification required.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Moorhead Post Office",
    address: "420 Center Ave, Moorhead, MN 56560",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(218) 236-7610",
    type: "Post Office",
    notes: "Ideal for Moorhead and Dilworth residents in the Fargo metro.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Casselton Post Office",
    address: "101 1st Ave N, Casselton, ND 58012",
    hours: "Mon–Fri 9:00am–4:00pm",
    phone: "(701) 347-4636",
    type: "Post Office",
    notes: "Serves western Cass County residents — 20 miles west of Fargo.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Mapleton Post Office",
    address: "7 Elm St, Mapleton, ND 58059",
    hours: "Mon–Fri 9:00am–1:30pm",
    phone: "(701) 282-8558",
    type: "Post Office",
    notes: "Small community facility for southeastern Fargo metro area.",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit Passport Applications in Fargo
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the passport acceptance facilities serving Fargo and the Red River Valley area. Fast Passport Center will tell you exactly which facility to visit and what to bring.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${f.type === "Post Office" ? "ri-mail-line" : "ri-building-2-line"} text-[#1A365D]`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>
              <ul className="space-y-2 text-sm text-gray-500 flex-1">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.address}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.hours}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.phone}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </li>
                <li className="flex items-start gap-2 pt-2 border-t border-gray-100 text-gray-400 italic">
                  <i className="ri-information-line text-gray-300 flex-shrink-0 mt-0.5"></i>
                  {f.notes}
                </li>
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-7 text-center">
          <h3 className="font-bold text-white text-lg mb-2">Not Sure Which Facility to Use?</h3>
          <p className="text-white/60 text-sm mb-5">
            Fast Passport Center will tell you exactly which acceptance facility is best for your location and schedule — and precisely what to bring.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            Get Personalized Guidance <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}